import rootPath from "../routes-path";

export { RouteProps } from "../routes-path";

export const path = "/soutezni-udaje";

export default rootPath + path;

export const vysledky = '/vysledky-soutezi';
export const vysledkyPath = path + vysledky;